import React, { useCallback, useEffect, useMemo, useState } from 'react';
import DataTable from 'components/shared/DataTable';
import Modal from 'components/shared/Modal';
import BWButton from 'components/shared/BWButton';
import { getComboOptions } from 'services/promotions.service';
import { defaultPaging } from 'utils/helpers';
import { formatPrice } from 'utils';
import styled from 'styled-components';

const FilterRow = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 12px;
  margin-bottom: 16px;

  input {
    height: 40px;
    border: 1px solid #d8e0ea;
    border-radius: 8px;
    padding: 0 12px;
    color: #1d2939;
  }
`;

const renderComboPrice = (item) => {
  const price = Number(item?.combo_price || 0);
  if (!price) {
    return <span style={{ color: '#98a2b3', fontWeight: 700 }}>Chưa làm giá</span>;
  }
  return (
    <div>
      <b>{`${formatPrice(price, false, '.')} đ`}</b>
      {item?.combo_price_id ? (
        <p style={{ marginTop: 3, color: '#667085', fontSize: 11, fontWeight: 700 }}>
          {item?.combo_output_type_name || 'SL_PRICES'}
        </p>
      ) : null}
    </div>
  );
};

const PromotionComboModal = ({ open, onClose, defaultDataSelect = [], onConfirm }) => {
  const [params, setParams] = useState({
    page: 1,
    itemsPerPage: 5,
    search: '',
  });
  const [keyword, setKeyword] = useState('');
  const [selectedCombos, setSelectedCombos] = useState(defaultDataSelect);
  const [loading, setLoading] = useState(false);
  const [comboData, setComboData] = useState(defaultPaging);

  const { items, itemsPerPage, page, totalItems, totalPages } = comboData;

  const loadComboOptions = useCallback(() => {
    setLoading(true);
    getComboOptions(params)
      .then((data) => {
        setComboData(data);
      })
      .finally(() => setLoading(false));
  }, [params]);

  useEffect(loadComboOptions, [loadComboOptions]);

  const columns = useMemo(
    () => [
      {
        header: 'Tên combo',
        accessor: 'combo_name',
        formatter: (item) => (
          <div>
            <b>{item?.combo_name}</b>
            {item?.combo_code ? <p style={{ color: '#667085', marginTop: 4 }}>{item.combo_code}</p> : null}
          </div>
        ),
      },
      {
        header: 'Nhóm combo',
        accessor: 'combo_type_name',
      },
      {
        header: 'Số sản phẩm',
        classNameHeader: 'bw_text_center',
        classNameBody: 'bw_text_center',
        accessor: 'product_count',
      },
      {
        header: 'Giá combo',
        classNameHeader: 'bw_text_right',
        classNameBody: 'bw_text_right',
        formatter: renderComboPrice,
      },
    ],
    [],
  );

  const handleSearch = () => {
    setParams((prev) => ({
      ...prev,
      page: 1,
      search: keyword,
    }));
  };

  return (
    <Modal
      witdh='72vw'
      header='Chọn combo khuyến mại'
      open={open}
      onClose={onClose}
      lalbelClose='Đóng'
      footer={
        <BWButton
          type='success'
          icon='fi fi-rr-check'
          content='Xác nhận'
          onClick={() => {
            onConfirm(selectedCombos);
            onClose();
          }}
        />
      }>
      <FilterRow>
        <input
          value={keyword}
          placeholder='Tìm tên combo, mã combo hoặc URL'
          onChange={(event) => setKeyword(event.target.value)}
          onKeyDown={(event) => {
            if (event.key === 'Enter') {
              event.preventDefault();
              handleSearch();
            }
          }}
        />
        <BWButton type='danger' icon='fi fi-rr-filter' content='Tìm kiếm' onClick={handleSearch} />
      </FilterRow>
      <DataTable
        plain
        hiddenActionRow
        hiddenDeleteClick
        fieldCheck='combo_id'
        loading={loading}
        columns={columns}
        data={items}
        defaultDataSelect={defaultDataSelect}
        totalPages={totalPages}
        itemsPerPage={itemsPerPage}
        page={page}
        totalItems={totalItems}
        onChangeSelect={(value) => setSelectedCombos(value)}
        onChangePage={(nextPage) => {
          setParams((prev) => ({
            ...prev,
            page: nextPage,
          }));
        }}
      />
    </Modal>
  );
};

export default PromotionComboModal;
